import { render, staticRenderFns } from "./modalAddBeneficio_managerMarket.vue?vue&type=template&id=398f7cea&scoped=true"
import script from "./modalAddBeneficio_managerMarket.vue?vue&type=script&lang=js"
export * from "./modalAddBeneficio_managerMarket.vue?vue&type=script&lang=js"
import style0 from "./modalAddBeneficio_managerMarket.vue?vue&type=style&index=0&id=398f7cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f7cea",
  null
  
)

export default component.exports